<template>
  <div class="compound public-content">
    <div class="breadcrumb">尺寸组管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0;font-weight: bold;">尺寸组类:</span>
        <el-select v-model="searchComposeSizeGroupVO.groupCategoryId" clearable placeholder="请选择">
          <el-option label="" value="">全部</el-option>
          <el-option v-for="item in sizeGroupTypeList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
        </el-select>
        <span style="margin:0 10px 0 20px;font-weight: bold;">尺寸组名称:</span>
        <el-input v-model="searchComposeSizeGroupVO.groupName" clearable placeholder="请输入尺寸组名称"></el-input>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        <el-button round type="primary" @click="manage()">尺寸组类管理</el-button>
        <el-button round type="primary" v-permission="'pts:admin:compose:size:group:add'" @click="searchSizeList(), dialogVisible = true">新建尺寸组</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column type="expand">
            <template v-slot='scope'>
              <div style="width:100%;height:100%;background:red">
                <el-table :data="scope.row.sizeList" border>
                  <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                  <el-table-column label="页面类型" prop="typeName">
                    <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
                  </el-table-column>
                  <el-table-column label="页面名称" prop="pageName"></el-table-column>
                  <el-table-column label="宽高">
                    <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                  </el-table-column>
                  <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                  <el-table-column label="出血" width="220px">
                    <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                    }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                  </el-table-column>
                  <el-table-column label="码名称" prop="barCodeId">
                    <template slot-scope="scope">
                      <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
          <el-table-column label="尺寸组类" prop="groupCategoryName" min-width="100px"></el-table-column>
          <el-table-column label="页面名称" prop="pageName" min-width="100px"></el-table-column>
          <el-table-column label="操作" min-width="100px">
            <template slot-scope="scope">
              <span class="color-blue" v-permission="'pts:admin:compose:size:group:detail'" @click="chack(scope.row)">查看</span><br>
              <span class="color-blue" v-permission="'pts:admin:compose:size:group:delete'" @click="deleteDialog = true, planDeleteSizeGroupId = scope.row.id">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 新建尺寸组 -->
    <el-dialog :close-on-click-modal="false" title="新建尺寸组" :visible.sync="dialogVisible" width="70%" @closed='closed'>
      <el-form :inline="true" :model="searchComposeSizeVo" class="demo-form-inline">
        <el-form-item label="页面类型:">
          <el-select clearable v-model="searchComposeSizeVo.pageTypeCode" placeholder="">
            <el-option v-for="item in $store.state.pms.pageTypeList" :key='item.id' :label="item.typeName" :value="item.typeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="尺寸名称:">
          <el-input v-model="searchComposeSizeVo.sizeName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addQueryInfo.pageNum = 1, searchSizeList()">查询</el-button>
        </el-form-item>
        <div>
          <el-form-item label="已选尺寸:">
            <span class='tag' v-for="(item, index) in choiceSizeList" :key="item.id" style="font-size:13px">{{ item.sizeName }}<i @click="deleteSize(index)" class="el-icon-close"></i></span>
          </el-form-item>
        </div>
        <div>
          <el-table :data="sizeTableData" border style="width: 100%">
            <el-table-column prop="sizeName" label="尺寸名称"></el-table-column>
            <el-table-column label="页面类型">
              <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
            </el-table-column>
            <el-table-column prop="pageName" label="页面名称"></el-table-column>
            <el-table-column prop="address" label="宽高">
              <template slot-scope="scope"> 宽度：{{ scope.row.sizeWidth }}<br>高度：{{ scope.row.sizeHeight }} </template>
            </el-table-column>
            <el-table-column prop="bleed.bleedName" label="出血类型"></el-table-column>
            <el-table-column label="出血" width="210px">
              <template slot-scope="scope"> 上：{{ scope.row.bleed.bleedTop }}mm 底部：{{ scope.row.bleed.bleedBottom }}mm<br> 内侧：{{ scope.row.bleed.bleedIn }}mm 外侧：{{ scope.row.bleed.bleedOut }}mm<br>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="折线">
              <template slot-scope="scope">
                <p v-for="(val, key) in scope.row.brokenLine" :key="key">{{ key === 'HORIZONTAL' ? '水平折线' : key === 'VERTICAL' ? '垂直折线' : '未定义字段' }}：<span v-for="item in val" :key="item">{{ item
                }}mm</span></p>
              </template>
            </el-table-column>
            <el-table-column prop="barCodeId" label="码名称">
              <template slot-scope="scope">
                <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <span @click="choiceSize(scope.row)" class="color-blue">选择</span>
              </template>
            </el-table-column>
          </el-table>
          <v-pagination class="v-pagination" :queryInfo="addQueryInfo" @changePage="addChangePage"></v-pagination>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="choicedSize">确 定</el-button>
      </span>
      <el-dialog :close-on-click-modal="false" width="30%" title="确定提示" :visible.sync="innerVisible" append-to-body>
        <el-form :model="ComposeSizeGroupVo" :rules="addRules" ref="addForm" label-width="100px">
          <el-form-item label="尺寸组名称:" prop="groupName">
            <el-input v-model="ComposeSizeGroupVo.groupName" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="尺寸组类:" prop="groupCategoryId">
            <el-select v-model="ComposeSizeGroupVo.groupCategoryId" placeholder="">
              <el-option v-for="item in sizeGroupTypeList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSizeGroup">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- 删除尺寸组确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>请取消绑定后删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteSizeGroup">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import { groupListPageing, groupDelete, composeGroupUsable, groupCategoryList, composeGroupAdd, bleedDetail, pageTypeList, sizeListPaging, composeGroupDetail } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      ComposeSizeGroupVo: {
        composeSizeIdSet: [],
        groupCategoryId: null,
        groupName: ''
      },
      searchComposeSizeVo: {
        pageName: '',
        pageTypeCode: '',
        sizeName: ''
      },
      formInline: {},
      dialogVisible: false,
      deleteDialog: false,
      innerVisible: false,
      composeList: [],
      keywords: '',
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addQueryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchComposeSizeGroupVO: {
        groupCategoryId: '',
        groupName: ''
      },
      compoundType: [],
      tableData: [],
      sizeFrom: [],
      sizeTypeList: [],
      sizeTableData: [],
      choiceSizeList: [],
      sizeGroupTypeList: [],
      nameLock: false,
      planDeleteSizeGroupId: '',
      addRules: {
        groupName: [
          { required: true, message: '请填写尺寸组名称', trigger: 'blur' }
        ],
        groupCategoryId: [
          { required: true, message: '请选择尺寸组类', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.searchComposeSizeGroupVO = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    this.onSubmit()
    this.$store.dispatch('pms/getPageTypeList')
    this.getSizeGroupTypeList()
  },
  methods: {
    manage () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchComposeSizeGroupVO))
      this.$router.push('/createsizegroup')
    },
    chack (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchComposeSizeGroupVO))
      this.$router.push({ path: '/checksizegroup', query: { id: row.id } })
    },
    choicedSize () {
      if (this.choiceSizeList.length === 0) {
        this.$message.error('未选择尺寸')
        return
      }
      this.innerVisible = true
    },
    closed () {
      this.searchComposeSizeVo = {
        pageName: '',
        pageTypeCode: '',
        sizeName: ''
      }
      this.choiceSizeList = []
      this.ComposeSizeGroupVo = {
        composeSizeIdSet: [],
        groupCategoryId: null,
        groupName: ''
      }
    },
    // 删除尺寸组
    deleteSizeGroup () {
      groupDelete(this.planDeleteSizeGroupId).then(res => {
        if (res.data.success) {
          this.onSubmit()
          this.$message.success('删除成功')
          this.deleteDialog = false
        }
      })
    },
    // 新建尺寸组
    addSizeGroup () {
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.nameLock) {
          return
        }
        this.nameLock = true
        // 先判断名称是否可用
        composeGroupUsable({ act: 0, groupName: this.ComposeSizeGroupVo.groupName }).then(res => {
          if (res.data.success) {
            composeGroupAdd(this.ComposeSizeGroupVo).then(res => {
              this.nameLock = false
              if (res.data.success) {
                this.onSubmit()
                this.$message.success('新建成功')
                this.innerVisible = false
                this.dialogVisible = false
              }
            })
          } else {
            this.nameLock = false
          }
        })
      })
    },
    // 获取尺寸组类
    getSizeGroupTypeList () {
      groupCategoryList().then(res => {
        if (res.data.success) {
          this.sizeGroupTypeList = res.data.data
        }
      })
    },
    // 删除选择的尺寸
    deleteSize (index) {
      this.ComposeSizeGroupVo.composeSizeIdSet.splice(index, 1)
      this.choiceSizeList.splice(index, 1)
    },
    // 选择尺寸
    choiceSize (row) {
      let lock = true
      this.choiceSizeList.forEach(item => {
        if (item.pageTypeCode === row.pageTypeCode) {
          this.$message.error('一个页面类型只能选一个尺寸')
          lock = false
        }
      })
      if (lock) {
        // 添加id
        this.ComposeSizeGroupVo.composeSizeIdSet.push(row.id)
        // 添加到页面
        this.choiceSizeList.push(row)
      }
    },
    // 获取页面类型
    // getPageTypeList () {
    //   pageTypeList().then(res => {
    //
    //     if (res.data.success) {
    //       this.sizeTypeList = res.data.data
    //     }
    //   })
    // },
    // 新建尺寸组查询尺寸
    searchSizeList () {
      sizeListPaging({ pageNum: this.addQueryInfo.pageNum, pageSize: this.addQueryInfo.pageSize, data: this.searchComposeSizeVo }).then(res => {
        if (res.data.success) {
          this.addQueryInfo.total = res.data.data.total
          let list = res.data.data.records
          list.forEach(item => {
            item.brokenLine = {}
            item.composeSizeBrokenLineXrefList.forEach(val => {
              if (!item.brokenLine[val.brokenLineDirection]) {
                item.brokenLine[val.brokenLineDirection] = []
              }
              item.brokenLine[val.brokenLineDirection].push(val.brokenLineValue)
            })
          })
          this.sizeTableData = list
        }
      })
    },
    // --------------------------------------------------------
    async expandChange (row, expandedRows) {
      await composeGroupDetail(row.id).then(res => {
        if (res.data.success) {
          row.detail = res.data.data
        } else {
          row.detail = []
        }
      })
    },
    // 查询尺寸组
    onSubmit () {
      groupListPageing({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, data: this.searchComposeSizeGroupVO }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          let list = res.data.data.records
          list.forEach(item => {
            // item.detail = []
            item.pageName = []
            item.sizeList.forEach(size => {
              item.pageName[item.pageName.length] = size.pageName
            })
            item.pageName = item.pageName.join(',')
          })
          this.tableData = list
        }
      })
    },
    getGroupMsg (val) {
      composeGroupDetail(val.id).then(res => {
        this.tableData.push({ groupCategoryName: val.groupCategoryName, ...res.data.data })
      })
    },
    deleteMenuOK () {
      this.onSubmit()
    },
    addMenuOK () {
      this.onSubmit()
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit(this.queryInfo)
    },
    addChangePage (val) {
      this.addQueryInfo = val
      this.searchSizeList()
    }
  }
}
</script>
<style scoped lang="less">
.tag {
  color: #666666;
  background-color: rgba(247, 247, 247, 1);
  border-width: 1px;
  border-style: solid;
  border-color: rgba(229, 230, 233, 1);
}

.compound {
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    .el-input {
      width: 180px;
    }
  }
}

@deep: ~">>>";

@{deep} .el-table__expanded-cell {
  // background: red;
  padding: 20px 23px;
  box-shadow: -1px 0px 13px 10px #ccc inset;
}
</style>
